import { autoinject } from "aurelia-framework";
import { FetchClient } from "../common/fetch-client";
import { IGetDMEByTermQuery } from "../resources-vue/vue-interfaces/i-get-dme";
import { DME } from "../resources-vue/vue-models/dme";

@autoinject()
export class DMEService {
    private _httpClient: FetchClient;
    private _baseUrl: string = "/api/v1/agency/dmes";

    public constructor(httpClient: FetchClient) {
        this._httpClient = httpClient;
    }

    public async getDMEByTerm(query: IGetDMEByTermQuery) {
        return await this._httpClient.build(`${this._baseUrl}`).useQueryString(query).fetch<DME[]>();
    }
}
